import { snoozePresets } from "@/lib/triage";
import { Box, Text } from "@okshaun/components";
import { css } from "@styled-system/css";
import { chipShapeRaw, pressableRaw } from "../overview/pressable";

const chip = css(pressableRaw, chipShapeRaw);

export const fieldClass = css({
  fontFamily: "mono",
  fontSize: "12",
  color: "text",
  bg: "bg.input",
  border: "default",
  borderColor: "border.input",
  borderRadius: "4",
  px: "8",
  py: "4",
  outline: "none",
  _focusVisible: { borderColor: "border.focused" },
});

interface DateChoiceProps {
  today: string;
  value: string;
  onChange: (date: string) => void;
  /** Reschedule only: the deadline it replaces. */
  from?: string;
}

/** Presets (+1 week, +2 weeks, +1 month) plus a date field. */
export function DateChoice({ today, value, onChange, from }: DateChoiceProps) {
  return (
    <Box display="flex" gap="6" alignItems="center" flexWrap="wrap">
      {from && (
        <Text textStyle="mono.xs" color="text.subtlest">
          from {from} to
        </Text>
      )}
      {snoozePresets(from ?? today).map((p) => (
        <button
          key={p.label}
          type="button"
          className={chip}
          aria-pressed={value === p.date}
          onClick={() => onChange(p.date)}
        >
          {p.label}
        </button>
      ))}
      <input
        type="date"
        aria-label="Date"
        className={fieldClass}
        min={today}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </Box>
  );
}
